import { render, staticRenderFns } from "./PaymentCollections.vue?vue&type=template&id=91883942&"
import script from "./PaymentCollections.vue?vue&type=script&lang=js&"
export * from "./PaymentCollections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports